import styled from 'styled-components';
import { Button } from 'ui-components/src/components/atoms/Button';
import { MultiSelect } from 'ui-components/src/components/atoms/Select/Multi';

export const Container = styled.div`
  margin-top: 16px;
`;

export const Row = styled.div`
  display: flex;
  margin-bottom: 16px;

  & > div {
    flex: 1;
  }
`;

export const AddButton = styled(Button)`
  height: 46px;
  line-height: 46px;
  margin-left: 0.5rem;
`;

export const StyledSelect = styled(MultiSelect)`
  flex: 1;
`;
